
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const PilaresSection = () => {
  const pilares = [
    {
      icon: 'ri-fire-line',
      title: 'Engenharia de Prevenção de Incêndio',
      description: 'Projetos técnicos para obtenção ou renovação do AVCB e CLCB. Consultoria completa e serviços técnicos especializados em sistemas de proteção contra incêndio, para-raios (SPDA), rede de gás (estanqueidade) e eletrotécnica.',
      services: [
        'Projetos AVCB e CLCB',
        'Regularização Bombeiros',
        'Inspeção e Manutenção do SPDA',
        'Treinamento de Brigada',
        'Laudos Elétricos',
        'Inspeção e Estanqueidade da Rede de Gás',
      ],
      link: '/servicos/prevencao-incendio',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Engenharia de Segurança do Trabalho',
      description: 'Elaboração de programas e laudos técnicos (NRs), gestão de riscos ocupacionais e eventos de SST no eSocial. Atuação como assistente técnico judicial em perícias de insalubridade e periculosidade, além de treinamentos corporativos.',
      services: [
        'Elaboração de PGR, LTCAT e PCMSO',
        'Consultoria Técnica',
        'Laudos de Insalubridade e Periculosidade',
        'PPP',
        'Treinamentos NRs',
        'Assistência Técnica Judicial',
      ],
      link: '/servicos/seguranca-trabalho',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Engenharia de Avaliações e Perícias',
      description: 'Perícias técnicas judiciais e extrajudiciais, avaliações patrimoniais e laudos especializados com rigor técnico e imparcialidade.',
      services: [
        'Perícias Judiciais',
        'Assistência Técnica',
        'Avaliações de Imóveis',
        'Laudos Especializados',
        'Pareceres Técnicos',
        'Diagnósticos Técnicos',
      ],
      link: '/servicos/avaliacoes-pericias',
    },
  ];

  return (
    <section className="bg-[#0A1628] py-14 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 lg:mb-16"
        >
          <h2 className="font-display font-bold text-2xl lg:text-5xl text-white mb-3 lg:mb-4">
            Nossos Pilares de Excelência Técnica
          </h2>
          <p className="text-sm lg:text-lg text-gray-400 max-w-2xl mx-auto">
            Três áreas de atuação integradas para oferecer soluções completas em engenharia especializada
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-8">
          {pilares.map((pilar, index) => (
            <motion.div
              key={pilar.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              whileHover={{ y: -8 }}
              className="bg-[#0F1F35] rounded-2xl p-6 lg:p-8 border border-gray-800 hover:border-[#D4AF37]/30 transition-all"
            >
              <div className="w-12 h-12 lg:w-16 lg:h-16 flex items-center justify-center bg-[#D4AF37]/10 rounded-xl mb-4 lg:mb-6">
                <i className={`${pilar.icon} text-3xl lg:text-4xl text-[#D4AF37]`}></i>
              </div>

              <h3 className="font-display font-bold text-xl lg:text-2xl text-white mb-3 lg:mb-4 leading-tight">
                {pilar.title}
              </h3>

              <p className="text-sm lg:text-base text-gray-400 leading-relaxed mb-4 lg:mb-6">
                {pilar.description}
              </p>

              <ul className="space-y-2 lg:space-y-3 mb-6 lg:mb-8">
                {pilar.services.map((service) => (
                  <li key={service} className="flex items-start gap-2 lg:gap-3">
                    <i className="ri-check-line text-[#D4AF37] text-base lg:text-lg mt-0.5 flex-shrink-0"></i>
                    <span className="text-xs lg:text-sm text-gray-300 leading-relaxed">{service}</span>
                  </li>
                ))}
              </ul>

              <Link
                to={pilar.link}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="inline-flex items-center gap-2 text-[#D4AF37] font-semibold hover:gap-3 transition-all whitespace-nowrap cursor-pointer text-sm lg:text-base"
              >
                Ver Serviços
                <i className="ri-arrow-right-line"></i>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PilaresSection;
